/* eslint no-undef: 0 */

/* eslint arrow-parens: 0 */
import { useEffect } from 'react'
import Head from 'next/head'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { Table, Row, Col, Typography } from 'antd'
import { GetFiledIposDocument } from 'graphql/generated/types'
import ApplicationLayout from 'layouts/application'
import { parseCookies, setCookie } from 'nookies'
import { PAGE_SIZE_FOR_PAGINATION } from 'shared/constants'
import { initializeApollo, addApolloState } from 'util/apolloClient'

const { Title } = Typography
const description = () =>
  `A Personal Finance FAQ portal for India, Canada & USA investors. Financial education hub sharing broker
reviews, stock market queries, trading & investment software and apps.`

const Ipos = (props) => {
  const pageSizeCount = 20
  const { data: records } = props
  const {
    all_brokers: allBrokers,
    all_calculators: allCalculators,
    all_pages: { data: allPages },
    filed_ipos: { data: filedRecords },
  } = records
  const {
    data: {
      filed_ipos: {
        meta: {
          pagination: { total },
        },
      },
    },
  } = props

  const router = useRouter()
  const { page = 1 } = router.query

  useEffect(() => {
    const cookies = parseCookies()
    if (!cookies.country) {
      setCookie(null, 'country', 'us', {
        path: ['/'], // cookie path
      })
    }
  }, [])
  const columns = [
    {
      title: 'Symbol',
      dataIndex: 'symbol',
      key: 'symbol',
      render: (text, record) => (
        <Link href={`/ipos/${record.slug}`}>{text}</Link>
      ),
    },
    {
      title: 'Company Name',
      dataIndex: 'companyName',
      key: 'companyName',
      render: (text, record) => (
        <Link href={`/ipos/${record.slug}`}>{text}</Link>
      ),
    },
    {
      title: 'Date Filed',
      dataIndex: 'dateFiled',
      key: 'dateFiled',
    },
    {
      title: 'Offer Amount',
      dataIndex: 'offerAmount',
      key: 'offerAmount',
    },
  ]
  const dataSource = filedRecords.map((item) => ({
    slug: item.attributes.slug,
    key: item.id,
    symbol: item.attributes.symbol,
    companyName: item.attributes.name,
    dateFiled: item.attributes.filed_date,
    offerAmount: item.attributes.offer_amount,
  }))

  return (
    <ApplicationLayout
      allBrokers={allBrokers.data}
      navCalculators={allCalculators.data}
      allPages={allPages}
    >
      <Head>
        <title>
          Latest Upcoming IPOs on NASDAQ - Fintrakk - Page {page || 1}
        </title>
        <meta name="description" content={description()} />
        {page === '1' && <link rel="canonical" href="/ipos/all" />}
      </Head>
      <Row className="page-wrapper page">
        <Col xs={24} md={16} sm={24}>
          <Title className="title-wrapper">Filings</Title>

          <Table
            columns={columns}
            dataSource={dataSource}
            bordered
            pagination={{
              current: parseInt(page as any, 10),
              pageSize: pageSizeCount,
              showSizeChanger: false,
              total,
              onChange: (changedPage) => {
                router.push(`/ipos/all/${changedPage.toString()}`)
              },
            }}
            scroll={{ x: true }}
          />
        </Col>
      </Row>
    </ApplicationLayout>
  )
}

export async function getServerSideProps(context) {
  const apolloClient = initializeApollo()
  const {
    query: { page = 1 },
  } = context

  const queryResults = await apolloClient.query({
    query: GetFiledIposDocument,
    variables: {
      currentPage: parseInt(page as any, 10),
      pageSizeCount: PAGE_SIZE_FOR_PAGINATION,
    },
  })

  const { data } = queryResults

  if (data.filed_ipos.data.length === 0) {
    return {
      notFound: true,
    }
  }

  return addApolloState(apolloClient, {
    props: queryResults,
  })
}

export default Ipos
